"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REFERRAL_TYPE = void 0;
var REFERRAL_TYPE;
(function (REFERRAL_TYPE) {
    REFERRAL_TYPE["UPDATED"] = "UPDATED";
})(REFERRAL_TYPE || (exports.REFERRAL_TYPE = REFERRAL_TYPE = {}));
